var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c("scrollTop", [_c("i", { staticClass: "icon-fa icon-fa-arrow-up" })]),
      _vm._v(" "),
      _vm.divisions
        ? _c("div", { staticClass: "card" }, [
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c(
                  "div",
                  {
                    staticClass: "btn-group btn-group-toggle divisions_select",
                    class: [{ disabled: _vm.loading }],
                  },
                  [
                    _c(
                      "label",
                      {
                        class: [
                          { active: _vm.selectedDivision == 0 },
                          "btn btn-outline-primary",
                        ],
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedDivision,
                              expression: "selectedDivision",
                            },
                          ],
                          attrs: {
                            disabled: _vm.loading,
                            type: "radio",
                            autocomplete: "off",
                          },
                          domProps: {
                            value: 0,
                            checked: _vm._q(_vm.selectedDivision, 0),
                          },
                          on: {
                            change: [
                              function ($event) {
                                _vm.selectedDivision = 0
                              },
                              function ($event) {
                                return _vm.showReport()
                              },
                            ],
                          },
                        }),
                        _vm._v(" "),
                        _vm._m(0),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm._l(
                  _vm.mixinGetSortedDivisions(1),
                  function (division, index) {
                    return _c(
                      "div",
                      {
                        key: division.id,
                        staticClass:
                          "btn-group btn-group-toggle divisions_select",
                        class: [{ disabled: _vm.loading }],
                      },
                      [
                        _c("DivisionBtn", {
                          attrs: {
                            loading: _vm.loading,
                            division: division,
                            divUsers: _vm.divUsers,
                            selectedDivision: _vm.selectedDivision,
                            showReport: _vm.showReport,
                          },
                        }),
                      ],
                      1
                    )
                  }
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _vm._l(
                  _vm.mixinGetSortedDivisions(2),
                  function (division, index) {
                    return _c(
                      "div",
                      {
                        key: division.id,
                        staticClass:
                          "btn-group btn-group-toggle divisions_select",
                        class: [{ disabled: _vm.loading }],
                      },
                      [
                        _c("DivisionBtn", {
                          attrs: {
                            loading: _vm.loading,
                            division: division,
                            divUsers: _vm.divUsers,
                            selectedDivision: _vm.selectedDivision,
                            showReport: _vm.showReport,
                          },
                        }),
                      ],
                      1
                    )
                  }
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _vm._l(
                  _vm.mixinGetSortedDivisions(3),
                  function (division, index) {
                    return _c(
                      "div",
                      {
                        key: division.id,
                        staticClass:
                          "btn-group btn-group-toggle divisions_select",
                        class: [{ disabled: _vm.loading }],
                      },
                      [
                        _c("DivisionBtn", {
                          attrs: {
                            loading: _vm.loading,
                            division: division,
                            divUsers: _vm.divUsers,
                            selectedDivision: _vm.selectedDivision,
                            showReport: _vm.showReport,
                          },
                        }),
                      ],
                      1
                    )
                  }
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _vm._l(
                  _vm.mixinGetSortedDivisions(3, 2),
                  function (division, index) {
                    return _c(
                      "div",
                      {
                        key: division.id,
                        staticClass:
                          "btn-group btn-group-toggle divisions_select",
                        class: [{ disabled: _vm.loading }],
                      },
                      [
                        _c("DivisionBtn", {
                          attrs: {
                            loading: _vm.loading,
                            division: division,
                            divUsers: _vm.divUsers,
                            selectedDivision: _vm.selectedDivision,
                            showReport: _vm.showReport,
                          },
                        }),
                      ],
                      1
                    )
                  }
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _vm._l(
                  _vm.mixinGetSortedDivisions(-1),
                  function (division, index) {
                    return _c(
                      "div",
                      {
                        key: division.id,
                        staticClass:
                          "btn-group btn-group-toggle divisions_select",
                        class: [{ disabled: _vm.loading }],
                      },
                      [
                        _c("DivisionBtn", {
                          attrs: {
                            loading: _vm.loading,
                            division: division,
                            divUsers: _vm.divUsers,
                            selectedDivision: _vm.selectedDivision,
                            showReport: _vm.showReport,
                          },
                        }),
                      ],
                      1
                    )
                  }
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "card-footer" }, [
              _c(
                "div",
                { staticClass: "flex justify-content-between" },
                [
                  _c(
                    "div",
                    [
                      _vm.selectedDate
                        ? _c("DateSelect", {
                            ref: "selectedDate",
                            attrs: {
                              onSelect: _vm.updateSelectedDate,
                              selectedDate: _vm.selectedDate,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "vue-ladda",
                    {
                      attrs: {
                        "button-class": "btn btn-success",
                        "data-style": "zoom-in",
                        loading: _vm.loading,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.showReport()
                        },
                      },
                    },
                    [_vm._v("Показать\n        ")]
                  ),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading
        ? _c("div", { staticClass: "row" }, [
            _vm.selectedDivision != 0
              ? _c(
                  "div",
                  { staticClass: "col-md-6 p-0 pr-1" },
                  [
                    _vm.selectedDivision != 0
                      ? [
                          _c("div", { staticClass: "card" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "card-header flex justify-content-between",
                              },
                              [
                                _c("h6", [_vm._v("Предварительное сальдо")]),
                                _vm._v(" "),
                                _vm.allowToExportOrders()
                                  ? _c(
                                      "div",
                                      { staticClass: "text-right flex-grow-1" },
                                      [
                                        _c("LoadingButton", {
                                          staticClass: "btn btn-outline-info",
                                          attrs: {
                                            title: "Выгрузить заявки в XLS",
                                            loading: _vm.exportLoading,
                                            type: "button",
                                            color: _vm.$constants.PRIMARY_COLOR,
                                            onClick: () => _vm.exportToXLS(),
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "card-body" },
                              [
                                _vm.balance
                                  ? _c("Saldo", {
                                      attrs: {
                                        division: _vm.selectedDivision,
                                        balance: _vm.balance,
                                        expenses: _vm.expenses,
                                        incomes: _vm.incomes,
                                        exchanges: _vm.reportData.exchanges,
                                        orders: _vm.orders.grouped,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.reportData &&
                          _vm.selectedDivision &&
                          _vm.divisions[_vm.selectedDivision] &&
                          _vm.divisions[_vm.selectedDivision].use_incashment
                            ? _c("div", { staticClass: "card" }, [
                                _vm._m(1),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "card-body" },
                                  [
                                    _vm.cashOutData
                                      ? [
                                          _c("CashOutBlock", {
                                            attrs: {
                                              actualRequest:
                                                _vm.reportData.incashmentsData,
                                              cashOutData: _vm.cashOutData,
                                              division: _vm.selectedDivision,
                                              selectedDate: _vm.selectedDate,
                                            },
                                          }),
                                        ]
                                      : [
                                          _c("p", [
                                            _vm._v(
                                              "Снятие недоступно в текущих условиях!"
                                            ),
                                          ]),
                                        ],
                                  ],
                                  2
                                ),
                              ])
                            : _vm._e(),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedDivision != 0
                      ? [
                          _c("div", { staticClass: "card" }, [
                            _c("div", { staticClass: "card-header" }, [
                              _c("h6", [
                                _vm._v("\n              Сальдо на "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.selectedDate)),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "card-body" }, [
                              _c(
                                "div",
                                { staticClass: "flex justify-content-between" },
                                [
                                  _c(
                                    "div",
                                    [
                                      _vm.cashOutData &&
                                      _vm.cashOutData.incashment &&
                                      _vm.cashOutData.incashment.report_date
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              [
                                                _vm._v(
                                                  "\n                    Закрыто инкассацией:\n                    "
                                                ),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.encashmentData.total.toLocaleString(
                                                        "ru-RU"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "v-popover",
                                                  {
                                                    staticClass: "d-inline",
                                                    attrs: {
                                                      placement: "bottom",
                                                      "auto-hide": true,
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "p-l-5 icon-fa icon-fa-info-circle expenses_tooltip_fa",
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "template",
                                                      { slot: "popover" },
                                                      [
                                                        _c("div", [
                                                          _c("p", [
                                                            _vm._v(
                                                              "\n                            Заявки:\n                            "
                                                            ),
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.encashmentData.adm_sum.toLocaleString(
                                                                    "ru-RU"
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("p", [
                                                            _vm._v(
                                                              "\n                            ЗП:\n                            "
                                                            ),
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.encashmentData.salary_sum.toLocaleString(
                                                                    "ru-RU"
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("p", [
                                                            _vm._v(
                                                              "\n                            Почтовые Р.:\n                            "
                                                            ),
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.encashmentData.post_sum.toLocaleString(
                                                                    "ru-RU"
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                          ]),
                                                        ]),
                                                      ]
                                                    ),
                                                  ],
                                                  2
                                                ),
                                              ],
                                              1
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.balance
                                        ? _c("Calculation", {
                                            ref: "balanceCalculation",
                                            attrs: {
                                              useCashOut:
                                                _vm.selectedDivision &&
                                                _vm.divisions[
                                                  _vm.selectedDivision
                                                ] &&
                                                _vm.divisions[
                                                  _vm.selectedDivision
                                                ].use_incashment,
                                              balance: _vm.balance,
                                              noCashOrders: _vm.noCashOrders,
                                              division: _vm.selectedDivision,
                                              divisions: _vm.divisions,
                                              dayData: _vm.reportData,
                                              expenses: _vm.expenses,
                                              incomes: _vm.incomes,
                                              refreshReport: _vm.showReport,
                                              exchanges:
                                                _vm.reportData.exchanges,
                                              orders: _vm.orders,
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  false && _vm.divisionExtraUsers
                                    ? _c("div", [
                                        _c(
                                          "table",
                                          {
                                            staticClass:
                                              "table division_users_table table-sm table-hover mt-0",
                                          },
                                          [
                                            _c(
                                              "tbody",
                                              [
                                                _vm._l(
                                                  _vm.divisionExtraUsers,
                                                  function (u) {
                                                    return _c("tr", [
                                                      _c("td", [
                                                        _vm._v(_vm._s(u.id)),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _vm._v(_vm._s(u.name)),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group",
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    u.amount,
                                                                  expression:
                                                                    "u.amount",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              attrs: {
                                                                type: "number",
                                                              },
                                                              domProps: {
                                                                value: u.amount,
                                                              },
                                                              on: {
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    )
                                                                      return
                                                                    _vm.$set(
                                                                      u,
                                                                      "amount",
                                                                      $event
                                                                        .target
                                                                        .value
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "input-group-append",
                                                              },
                                                              [
                                                                _c(
                                                                  "LoadingButton",
                                                                  {
                                                                    attrs: {
                                                                      title:
                                                                        '<i class="icon-fa icon-fa-save"></i>',
                                                                      className:
                                                                        "btn btn-outline-info",
                                                                      onClick:
                                                                        () =>
                                                                          _vm.updateDivisionUserBalance(
                                                                            u
                                                                          ),
                                                                      loading:
                                                                        _vm.userBalanceLoading,
                                                                      color:
                                                                        _vm
                                                                          .$constants
                                                                          .PRIMARY_COLOR,
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                      ]),
                                                    ])
                                                  }
                                                ),
                                                _vm._v(" "),
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    { attrs: { colspan: "2" } },
                                                    [_vm._v("не распределено")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getBalanceRemain()
                                                        )
                                                      ),
                                                    ]),
                                                  ]),
                                                ]),
                                              ],
                                              2
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            this.$can("display/report/ordersSum") &&
            _vm.divisionAccess.ordersSum &&
            _vm.orders &&
            _vm.orders.grouped &&
            Object.keys(_vm.orders.grouped).length
              ? _c("div", { staticClass: "col-md-6 p-0" }, [
                  _c("div", { staticClass: "card" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "card-body",
                        staticStyle: { "padding-top": "5px" },
                      },
                      [
                        _c("div", { staticClass: "form-group m-0" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.showOrdersCostPrice,
                                expression: "showOrdersCostPrice",
                              },
                            ],
                            attrs: { type: "checkbox", id: "ch_order_cost" },
                            domProps: {
                              checked: Array.isArray(_vm.showOrdersCostPrice)
                                ? _vm._i(_vm.showOrdersCostPrice, null) > -1
                                : _vm.showOrdersCostPrice,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.showOrdersCostPrice,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.showOrdersCostPrice = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.showOrdersCostPrice = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.showOrdersCostPrice = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "pointer",
                              attrs: { for: "ch_order_cost" },
                            },
                            [_vm._v("показать расшифровку заявок по прибыли")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group m-0" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.showOrdersStatistics,
                                expression: "showOrdersStatistics",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              id: "ch_order_statistics",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.showOrdersStatistics)
                                ? _vm._i(_vm.showOrdersStatistics, null) > -1
                                : _vm.showOrdersStatistics,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$a = _vm.showOrdersStatistics,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.showOrdersStatistics = $$a.concat([
                                          $$v,
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.showOrdersStatistics = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.showOrdersStatistics = $$c
                                  }
                                },
                                function ($event) {
                                  return _vm.getOrders("closedOrders", true)
                                },
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "pointer",
                              attrs: { for: "ch_order_statistics" },
                            },
                            [_vm._v("показать статистику")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "table",
                            {
                              staticClass: "table table-sm table-hover m-md-0",
                            },
                            [
                              _vm._m(3),
                              _vm._v(" "),
                              _c("tbody", [
                                _c("tr", [
                                  _c("td", [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          (_vm.orders.grouped.total_price &&
                                            _vm.orders.grouped.total_price.toLocaleString(
                                              "ru-RU"
                                            )) ||
                                            0
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          (_vm.orders.grouped.total_salary &&
                                            _vm.orders.grouped.total_salary.toLocaleString(
                                              "ru-RU"
                                            )) ||
                                            0
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          (_vm.orders.grouped.total_post &&
                                            _vm.orders.grouped.total_post.toLocaleString(
                                              "ru-RU"
                                            )) ||
                                            0
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          (_vm.orders.grouped.total_pass &&
                                            _vm.orders.grouped.total_pass.toLocaleString(
                                              "ru-RU"
                                            )) ||
                                            0
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm._m(4),
                              _vm._v(" "),
                              _c("tbody", [
                                _c("tr", [
                                  _c("td", [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          (_vm.orders.grouped.price_in_eur &&
                                            _vm.orders.grouped.price_in_eur.toLocaleString(
                                              "ru-RU"
                                            )) ||
                                            0
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          (_vm.orders.grouped.total_cost &&
                                            _vm.orders.grouped.total_cost.toLocaleString(
                                              "ru-RU"
                                            )) ||
                                            0
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.allExpensesSum.toLocaleString(
                                            "ru-RU"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          (
                                            _vm.orders.grouped.price_in_eur -
                                            _vm.orders.grouped.total_cost -
                                            _vm.allExpensesSum
                                          ).toLocaleString("ru-RU")
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.customSalaryCalculation
                    ? _c("div", { staticClass: "card" }, [
                        _vm._m(5),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-body" }, [
                          _c("p", [
                            _vm._v("ставка: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.customSalaryCalculation.basic.amount
                                ) +
                                  "\n            " +
                                  _vm._s(
                                    _vm.customSalaryCalculation.basic.type ===
                                      "percent"
                                      ? "%"
                                      : "р"
                                  )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("процент: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.customSalaryCalculation.rate.amount
                                ) +
                                  "\n            " +
                                  _vm._s(
                                    _vm.customSalaryCalculation.rate.type ===
                                      "percent"
                                      ? "%"
                                      : "р"
                                  )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("надбавка: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.customSalaryCalculation.bonus.amount
                                ) +
                                  "\n            " +
                                  _vm._s(
                                    _vm.customSalaryCalculation.bonus.type ===
                                      "percent"
                                      ? "%"
                                      : "р"
                                  )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("расходы: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.customSalaryCalculation.expenses.amount
                                ) +
                                  "\n            " +
                                  _vm._s(
                                    _vm.customSalaryCalculation.expenses
                                      .type === "percent"
                                      ? "%"
                                      : "р"
                                  )
                              ),
                            ]),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  (_vm.balance.nonConfirmedExpenses ?? []).filter(
                    (e) => !e.is_confirmed
                  ).length ||
                  (_vm.balance.nonConfirmedIncomes ?? []).filter(
                    (e) => !e.is_confirmed
                  ).length
                    ? _c("div", { staticClass: "card" }, [
                        _vm._m(6),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "card-body" },
                          [
                            _c("NonConfirmedExpenses", {
                              attrs: {
                                expenses: _vm.balance.nonConfirmedExpenses,
                                "expenses-types": _vm.expensesTypes,
                              },
                            }),
                            _vm._v(" "),
                            _c("NonConfirmedIncomes", {
                              attrs: {
                                records: _vm.balance.nonConfirmedIncomes,
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showOrdersStatistics && !_vm.loading
        ? _c("div", { staticClass: "card" }, [
            _vm._m(7),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c("pulse-loader", {
                  staticClass: "text-center",
                  attrs: {
                    loading: _vm.loadingOrdersBtn,
                    color: _vm.$constants.LOADING_COLOR,
                  },
                }),
                _vm._v(" "),
                !_vm.loadingOrdersBtn
                  ? [
                      _c("h5", [_vm._v("Закрытые заявки")]),
                      _vm._v(" "),
                      _c("OrdersStatistics", {
                        attrs: {
                          orders: _vm.orders.list,
                          selectedDivision: _vm.selectedDivision,
                        },
                      }),
                      _vm._v(" "),
                      _c("h5", [_vm._v("Обработанные заявки")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.countManualOrders,
                              expression: "countManualOrders",
                            },
                          ],
                          attrs: { type: "checkbox", id: "ch__1" },
                          domProps: {
                            checked: Array.isArray(_vm.countManualOrders)
                              ? _vm._i(_vm.countManualOrders, null) > -1
                              : _vm.countManualOrders,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.countManualOrders,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.countManualOrders = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.countManualOrders = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.countManualOrders = $$c
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "ch__1" } }, [
                          _vm._v(
                            "Засчитывать также доставочные, созданные вручную"
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("OrdersStatistics", {
                        attrs: {
                          showNewOrders: _vm.countManualOrders,
                          orders: _vm.statOrders,
                          selectedDivision: _vm.selectedDivision,
                        },
                      }),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.reportData
        ? _c("div", { staticClass: "card" }, [
            _vm._m(8),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-body p-t-1" },
              [
                _c("ExpensesBlock", {
                  attrs: {
                    expenses: _vm.expenses,
                    types: _vm.expensesTypes,
                    division: _vm.selectedDivision,
                    currencies: _vm.allowedCurrencies,
                    userId: _vm.currentUserId,
                    users: _vm.runnerNames,
                    date: _vm.selectedDate,
                    chiefRunners: _vm.divisionChiefRunners,
                    expensesUsers: _vm.divisionExtraUsers,
                    updateExpenses: _vm.updateExpenses,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.reportData
        ? _c("div", { staticClass: "card" }, [
            _vm._m(9),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-body p-t-1" },
              [
                _c("IncomesBlock", {
                  ref: "IncomesBlock",
                  attrs: {
                    records: _vm.incomes,
                    disabledRecords: _vm.allIncomes,
                    currencies: _vm.allowedCurrencies,
                    date: _vm.selectedDate,
                    receivers: _vm.getAllowedReceivers(),
                    userId: _vm.currentUserId,
                    users: _vm.runnerNames,
                    division: _vm.selectedDivision,
                    updateRecords: _vm.updateIncomes,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      (_vm.selectedDivision || _vm.selectedDivision != "null") && _vm.reportData
        ? _c("div", { staticClass: "card" }, [
            _vm._m(10),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-body p-t-1" },
              [
                _c("CurrencyExchangeBlock", {
                  attrs: {
                    records: _vm.reportData.exchanges,
                    currencies: _vm.allowedCurrencies,
                    date: _vm.selectedDate,
                    users: _vm.runnerNames,
                    userId: _vm.currentUserId,
                    division: _vm.selectedDivision,
                    updateRecords: _vm.updateExchanges,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.divisionAccess.closedOrders && _vm.orders
        ? _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-header" }, [
              _c("h6", [
                _vm._v("\n        Выполненные заявки\n        "),
                _c("strong", [
                  _vm._v("(" + _vm._s(_vm.orders.grouped.total_orders) + ")"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "pull-right" },
                  [
                    _c("LoadingButton", {
                      attrs: {
                        title: _vm.showOrders ? "Скрыть" : "Показать",
                        className: "btn btn-default",
                        loading: _vm.loadingOrdersBtn,
                        color: _vm.$constants.PRIMARY_COLOR,
                        onClick: () => _vm.getOrders("closedOrders"),
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _vm.showOrders && _vm.orders.list.length
                  ? _c("OrderList", {
                      attrs: {
                        encashmentDate:
                          (_vm.cashOutData &&
                            _vm.cashOutData.incashment &&
                            _vm.cashOutData.incashment.report_date) ||
                          false,
                        showOrdersCostPrice: _vm.showOrdersCostPrice,
                        currentRate: _vm.currentRate,
                        orders: _vm.orders.list,
                        showOrders: _vm.showOrders,
                        runnerNames: _vm.runnerNames,
                        ordersSummary: _vm.orders.grouped,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && _vm.rejectedOrders && _vm.rejectedOrders.length
        ? _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-header" }, [
              _c("h6", [
                _vm._v("\n        Отмененные заявки\n        "),
                _c("strong", [
                  _vm._v("(" + _vm._s(_vm.rejectedOrders.length) + ")"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pull-right" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default",
                      on: {
                        click: function ($event) {
                          _vm.showRejectedOrders = !_vm.showRejectedOrders
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.showRejectedOrders ? "Скрыть" : "Показать"
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c("OrderList", {
                  attrs: {
                    ordersSummary: {},
                    statuses: [-3],
                    showComment: true,
                    showOrdersCostPrice: _vm.showOrdersCostPrice,
                    currentRate: _vm.currentRate,
                    orders: (_vm.orders && _vm.orders.list) || [],
                    showOrders: _vm.showRejectedOrders,
                    runnerNames: _vm.runnerNames,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticClass: "division_runner" }, [_vm._v("Сводный")]),
      _vm._v(" "),
      _c("p", { staticClass: "d_info_city" }, [_vm._v("отчет")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Запрос на снятие")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Данные по заявкам")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("общая сумма")]),
        _vm._v(" "),
        _c("th", [_vm._v("ЗП")]),
        _vm._v(" "),
        _c("th", [_vm._v("почт. р.")]),
        _vm._v(" "),
        _c("th", [_vm._v("к сдаче")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Валовая EUR")]),
        _vm._v(" "),
        _c("th", [_vm._v("Себест.")]),
        _vm._v(" "),
        _c("th", [_vm._v("Расходы")]),
        _vm._v(" "),
        _c("th", [_vm._v("Прибыль")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("strong", [_vm._v("Специальный просчет ЗП курьеров")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header bg-warning" }, [
      _c("h6", [_vm._v("Операции без подтверждения")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Статистика заявок")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Расходы")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Инкассации")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Покупка валюты")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }